let _pool = [];

function getCanvas(contextType = '2d') {
    const idleCanvas = _pool.find(item => item && item.idle && item.getContext(contextType));
    if (idleCanvas) {
        idleCanvas.idle = false;
        return idleCanvas;
    }
    const canvas = document.createElement('canvas');

    // getContext 的目的是为了确保 contextType 的正确使用
    canvas.getContext(contextType);
    canvas.isPoolCanvas = true;
    canvas.idle = false;
    _pool.push(canvas);

    return canvas;
}

function releaseCanvas(canvas) {
    if (!canvas || !(canvas instanceof HTMLCanvasElement) || canvas.idle) {
        return;
    }

    canvas.idle = true;
    if (_pool.indexOf(canvas) === -1) {
        _pool.push(canvas);
    }

    canvas.getContext('2d')?.clearRect(0, 0, canvas.width, canvas.height);
    // TODO: 同步清除 style, 还回来的canvas不干净，需要清除，不好在外部去排查，后续如果又类似问题，先优先讨论其他方案，迫不得已再在这里处理
    canvas.style = '';
}


function clear() {
    _pool.forEach(canvas => {
        // if (canvas.idle) canvas.getContext('2d')?.clearRect(0, 0, canvas.width, canvas.height);
        if (canvas.idle) canvas.width = canvas.height = 0;
    });

    _pool.length = 0;
}
// TODO 待弃用的池，使用FJPoolStore代替。目前除了输出外，一般不使用
export default { getCanvas, releaseCanvas, clear };
